const SectionResultsSummary = Class(
  /**
   * @lends {SectionMap#}
   */
  {

    route () {
      this.hash = this.url.shift();
    },

    __construct () {
      this.node = mkE({
        tag: 'div',
        id: 'SectionResultsSummary',
      }).append(this.layout.ct());
    },

    draw () {
      fetch(
        this.url.get.toUrl(),
        {
          headers: { 'Accepts': 'application/json' }
        }
      ).then(response => {
        if (response.status !== 200) {
          throw 'Invalid';
        }
        return response.json();
      }).then(json => {
        if (json.meta) {
          this.meta
            .setTitle(json.meta.title)
            .setDescription(json.meta.description)
            .setOgTitle(json.meta.ogTitle)
            .setOgDescription(json.meta.ogDescription)
            .setOgImage(json.meta.ogImage)
            .setAlternate(json.meta.alternates)
            .setCanonical(json.meta.canonical)
            .setRobots(json.meta.robots);

          if (json.meta.alternates) {
            mkE({
              tag: 'div',
              className: 'container',
              style: {
                position: 'relative'
              },
              els: [
                {
                  tag: 'label',
                  style: {
                    position: 'absolute',
                    top: '16px',
                    right: '0',
                    display: 'block',
                    background: 'url(/assets/images/lang.svg) no-repeat center left',
                    backgroundSize: '16px',
                    paddingLeft: '22px',
                    fontSize: '15px'
                  },
                  els: [
                    {
                      tag: 'select',
                      style: {
                        border: '0px',
                        background: 'transparent',
                        color: '#fff',
                        textTransform: 'uppercase',
                      },
                      onchange: (e) => {
                        window.location = e.currentTarget.value + '?app-webview';
                      },
                      els: (() => {
                        let re = [];
                        for (const [key, value] of Object.entries(json.meta.alternates)) {
                          if (key === 'x-default') {
                            continue;
                          }
                          re.push({
                            tag: 'option',
                            text: key,
                            value: value,
                            selected: D.LANG === key,
                            style: { color: '#000' },
                          });
                        }
                        return re;
                      })()
                    }
                  ]
                }
              ]
            }).append(this.node);
          }
        }
        for (let i = 0; i < json.files.length; i++) {
          const file = json.files[i];
          fetch(file.src)
            .then(response => {
              if (response.status !== 200) {
                throw 'Invalid';
              }
              return response.text();
            })
            .then(content => {
              if (file.type === 'css') {
                mkE({
                  tag: 'style',
                  innerHTML: content
                }).append(this.node);
              } else if (file.type === 'html') {
                mkE({
                  tag: 'div',
                  innerHTML: content
                }).append(this.node);
              }
            });
        }
      }).catch(e => {
        console.error(e);
        const section = new SectionUnknown();
        section.url = this.url;
        section.show();
      });

      this.ready();
    }
  },
  Section
);